import React from "react";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import HeroSection from "../../components/HeroSection/HeroSection";
import HeroCaption from "../../components/HeroCaption/HeroCaption";
import ProgramDescriptionResponsive from "../../components/ProgramDescriptionResponsive/ProgramDescriptionResponsive";
import ResourcesResponsive from "../../components/ResourcesResponsive/ResourcesResponsive";
import MBAChoiceOfElectivesResponsive from "../../components/MBAChoiceOfElectivesResponsive/MBAChoiceOfElectivesResponsive";

const BTechMechProgramPage = () => {
	return (
		<PageWrapper className="mt-n6">
			<HeroSection className="bg-page-background-7">
				<HeroCaption
					title="Academics"
					position="bottom-left"
					breadcrumb={true}
					breadcrumbPrefix="Home"
				/>
			</HeroSection>
			<ProgramDescriptionResponsive
				title="B.Tech in Mechanical Engineering"
				desc="Our B.Tech in Mechanical Engineering program is designed to provide students with a comprehensive understanding of mechanical systems, materials, and manufacturing processes. Graduates of this program are well-prepared to pursue careers in aerospace, automotive, or manufacturing industries."
			/>
			{/* <MBAChoiceOfElectivesResponsive /> */}
			{/* <ResourcesResponsive headerContent={""} /> */}
		</PageWrapper>
	);
};

export default BTechMechProgramPage;
